
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mail-send-complete",
      function () {
        return require("private-next-pages/mail-send-complete/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mail-send-complete"])
      });
    }
  